import { Field, Form, withFormik } from 'formik';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import { object, string } from 'yup';

import { Button } from '@frontend/legacy-components';

import Checkbox from 'components/lib2/Checkbox';
import FormHelpers from 'components/lib2/FormHelpers';
import Input from 'components/lib2/TextInput';

import messages from 'constants/messages';

import { save, workStepsModal } from './data/actions';
import { MODES } from './data/constants';
import { getIsSaving, getMode, getWorkStep } from './data/reducer';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
`;

const Explanation = styled.ul`
  padding-left: 3rem;
`;

const ExplanationPoint = styled.li`
  color: #666;
  list-style: circle;
`;

const enhance = compose(
  connect(
    (state) => ({
      isSaving: getIsSaving(state),
      mode: getMode(state),
      workStep: getWorkStep(state),
    }),
    {
      close: workStepsModal.close,
      save: save.request,
    },
  ),
  withFormik({
    enableReinitialize: true,
    handleSubmit: ({ name, updateExistingQuoteItems }, { props }) => {
      const { save } = props;
      save({ name, updateExistingQuoteItems });
    },
    mapPropsToValues: ({ mode, workStep }) => ({
      name: (workStep && workStep.name) || '',
      updateExistingQuoteItems: mode === MODES.EDIT ? true : undefined,
    }),
    validateOnBlur: true,
    validateOnChange: true,
    validationSchema: object().shape({
      name: string().required(messages.REQUIRED),
    }),
  }),
);

const EditWorkStepForm = ({ isSaving, mode }) => {
  return (
    <Form>
      <FormHelpers.Group>
        <Field name="name">
          {({ form, field }) => (
            <FormHelpers.Field
              label="Name"
              error={form.touched[field.name] && form.errors[field.name]}
            >
              <Input autoComplete="none" name="name" autoFocus {...field} />
            </FormHelpers.Field>
          )}
        </Field>
        {mode === MODES.EDIT && (
          <Field name="updateExistingQuoteItems">
            {({ field, form }) => (
              <div>
                <Checkbox
                  checked={field.value}
                  onChange={(e) =>
                    form.setFieldValue(field.name, e.target.checked)
                  }
                >
                  <p>Persist changes to existing quote items</p>
                </Checkbox>
                <Explanation>
                  <ExplanationPoint>
                    If selected, all existing quote items with this step will
                    remain with the same status, but will now have this new
                    name.
                  </ExplanationPoint>
                  <ExplanationPoint>
                    If <b>not</b> selected, all existing quote items with this
                    step will keep their current status and will now also have
                    this step. The pre-existing statuses will not show up on
                    your dashboard.
                  </ExplanationPoint>
                </Explanation>
              </div>
            )}
          </Field>
        )}
      </FormHelpers.Group>
      <ButtonWrapper>
        <Button variant="primary" type="submit" isLoading={isSaving}>
          Save
        </Button>
      </ButtonWrapper>
    </Form>
  );
};

export default enhance(EditWorkStepForm);
